<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div>
            <div v-if="!registerEntityId && canWrite && !isLockedForEdit" class="col-12">
                <!-- <span class="float-left"><toggle v-model="budget.isExpensesGenerated"></toggle></span>
                <span class="float-left ml-3">{{ $t('budget.generateExpenses') }}</span> -->
            </div>
            <div v-else>
                <!-- <div v-if="budget && budget.items && budget.items.length > 0">
                    <toggle v-model="budget.isExpensesGenerated" :disabled="financialControl"></toggle>
                    {{ $t('budget.generateExpenses') }}
                </div> -->
                <div v-if="isNew" class="mb-3">
                    <dynamic-dropdown
                        :api-url="'/api/BudgetTemplate'"
                        v-model="templateId"
                        label="Избери шаблон">
                    </dynamic-dropdown>
                </div>
                <div  class="input-group mb-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text mr-2"><i class="fas fa-search text-secondary"></i></div>
                    </div>
                    <input
                        type="search"
                        class="form-control"
                        v-model="searchString"
                        :placeholder="$t('searchBox.placeholder')"
                        autocomplete="off"
                    />
                </div>
                <table class="table table-bordered table-responsive" v-if="budget.items && budget.items.length > 0 && optionsLoaded">
                    <thead>
                        <tr>
                            <th v-if="!isLockedForEdit"></th>
                            <th v-if="!isLockedForEdit && showSyncButton"></th>
                            <th>{{ $t('budget.group') }}</th>
                            <th>{{ $t('budget.tariffItem') }}</th>
                            <th>{{ $t('budget.description') }}</th>
                            <th>{{ $t('budget.date') }}</th>
                            <th>{{ $t('budget.quantity') }}</th>
                            <th>{{ $t('budget.singlePrice') }}</th>
                            <th>{{ $t('budget.total') }}</th>
                            <th>{{ $t('lastUpdate') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <budget-planning-row
                            v-for="(item, $index) in filteredItems.slice(pagination.currentPage * pagination.itemsPerPage, (pagination.currentPage * pagination.itemsPerPage) + pagination.itemsPerPage)"
                            :key="item.uid"
                            :item="item"
                            :index="$index"
                            :is-locked-for-edit="isLockedForEdit"
                            :show-sync-button="!isLockedForEdit && showSyncButton && canWrite"
                            :tariff-options="tariffOptions"
                            @deleteItem="deleteItem"
                            @addExpense="onAddOrUpdateExpense"
                            @updateExpense="onAddOrUpdateExpense"
                        />
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="10" class="font-weight-bold">{{ $t('budget.total') }}: {{ total }}</td>
                        </tr>
                    </tfoot>
                </table>
                <div class="row" v-if="totalPages > 0">
                    <ul class="col pagination justify-content-center mb-0" >
                        <li class="page-item">
                            <button type="button" class="btn btn-link btn-primary m-0" :disabled="pagination.currentPage === 0" @click.prevent="goToPage(0)">
                                <i class="fas fa-angle-double-left"></i>
                            </button>
                        </li>
                        <li class="page-item">
                            <button type="button" class="btn btn-link btn-primary m-0" :disabled="pagination.currentPage === 0" @click.prevent="goToPage(pagination.currentPage - 1)">
                                <i class="fas fa-caret-left"></i>
                            </button>
                        </li>
                        <li class="page-item" :class="pagination.currentPage === page - 1 ? 'active' : ''" v-for="(page) in totalPages" :key="page">
                            <button type="button" class="btn btn-link page-link" @click.prevent="goToPage(page - 1)">{{ page }}</button>
                        </li>
                        <li v-if="pagination.currentPage !== totalPages - 1" class="page-item">
                            <button type="button" class="btn btn-link btn-primary m-0" :disabled="pagination.currentPage === totalPages - 1" @click.prevent="goToPage(pagination.currentPage + 1)">
                                <i class="fas fa-caret-right"></i>
                            </button>
                        </li>
                        <li class="page-item">
                            <button type="button" class="btn btn-link btn-primary m-0" :disabled="pagination.currentPage === totalPages - 1" @click.prevent="goToPage(totalPages - 1)">
                                <i class="fas fa-angle-double-right"></i>
                            </button>
                        </li>
                    </ul>
                </div>
                <div>
                    <button v-if="canWrite && !isLockedForEdit" class="btn btn-primary" @click="addRow">{{ $t('add') }}</button>
                    <button v-if="canWrite && !isLockedForEdit" class="btn btn-primary" @click="onSave">{{ $t('save') }}</button>
                    <button class="btn btn-primary float-right" @click.stop="loadData">{{ $t('buttons.load.btnText') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BudgetPlanningRow from './BudgetPlanningRow';
    import { BudgetPlanningModel, BudgetPlanningRowModel } from '@/models/models';
    import DynamicDropdown from '../dropdown/DynamicDropdown';

    export default {
        props: {
            registerEntityId: {
                type: [Number, String],
                required: true
            },
            eventDateFrom: {
                type: [Date, String]
            },
            eventDateTo: {
                type: [Date, String]
            },
            canWrite: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
            showSyncButton: {
                type: Boolean,
                default: false
            }
        },
        components: {
            BudgetPlanningRow,
            DynamicDropdown,
        },
        data() {
            return {
                loading: false,
                templateId: '',
                isNew: true,
                financialControl: false,
                budget: new BudgetPlanningModel({ registerEntityId: this.registerEntityId, items: [] }),
                itemsToDelete: [],
                isLoaded: <i class="fa fa-assistive-listening-systems" aria-hidden="true"></i>,
                pagination: {
                    currentPage: 0,
                    itemsPerPage: 5
                },
                searchString: '',
                tariffOptions: [],
                optionsLoaded: false
            }
        },
        computed: {
            totalPages() {
                if (!this.filteredItems) return 0;
                return Math.ceil(this.filteredItems.length / this.pagination.itemsPerPage);
            },
            filteredItems() {
                if (!this.budget) return [];
                if (!this.budget.items) return [];
                if (!this.searchString || this.searchString.trim() === '') return this.budget.items;

                const search = this.searchString.toLowerCase().trim();
                return this.budget.items.filter(item => this.filterData(item, search));
            },
            total() {
                let totalSum = 0;
                if (this.budget && this.budget.items) {
                    this.budget.items.forEach(item => {
                        const itemTotal = item.qty * item.price;
                        if (itemTotal) {
                            totalSum += Math.round(itemTotal * 100) / 100;
                        }
                });
                }

                return Math.round(totalSum * 100) / 100;
            }
        },
        methods: {
            loadData() {
                this.loading = true;
                this.$http.get(`/api/Budget/GetByRegisterEntityId/${this.registerEntityId}`).then(result => {
                    if (result.data) {
                        this.budget = new BudgetPlanningModel(result.data);
                        this.financialControl = this.budget.isExpensesGenerated;
                        this.isNew = false;
                    }
                    this.loading = false;
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => {
                    this.loading = false;
                });
            },
            loadTariffOptions() {
                this.$http.get(`/api/Tariffs/getTariffItems`).then(result => {
                    if (result.data) {
                        this.tariffOptions = result.data.map((item) => {
                            return {
                                id: item.id,
                                text:
                                    this.isEnVersion && item.textEn
                                        ? item.textEn
                                        : item.text,
                                isRegisterField: item.isRegisterField,
                                item: item
                            }
                        });
                    }
                })
                .finally(() => {
                    this.optionsLoaded = true;
                });
            },
            populateFromTemplate(templateId) {
                this.loading = true;
                this.$http.get(`/api/BudgetTemplate/${templateId}/${false}`).then(result => {
                    result.data.id = undefined;
                    this.budget = new BudgetPlanningModel(result.data);
                    this.budget.registerEntityId = this.registerEntityId;
                    this.budget.isFromTemplate = true;
                    this.loading = false;
                    this.isLoaded = true;
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => {
                    this.loading = false
                });
            },
            addRow() {
                const uniqueId = `temp-${this.$helpers.getUid()}-${Date.now()}`;
                this.budget.items.push(new BudgetPlanningRowModel({ uid: uniqueId }));
                this.isLoaded = true;

                // Navigate to last page to show the newly added item
                this.$nextTick(() => {
                    const newTotalPages = Math.ceil(this.budget.items.length / this.pagination.itemsPerPage);
                    const lastPageIndex = newTotalPages - 1;

                    // Only navigate if we're not already on the last page
                    if (this.pagination.currentPage !== lastPageIndex) {
                        this.pagination.currentPage = lastPageIndex;
                    }
                });
            },
            deleteItem(index) {
                const itemToDelete = this.budget.items[index];
                if (itemToDelete.id) {
                    this.itemsToDelete.push(itemToDelete.id);
                    this.budget.itemsToDelete = this.itemsToDelete;
                }
                this.budget.items.splice(index, 1);

                // Ensure pagination doesn't exceed available pages
                this.$nextTick(() => {
                    if (this.pagination.currentPage >= this.totalPages && this.totalPages > 0) {
                        this.pagination.currentPage = this.totalPages - 1;
                    }
                });
            },
            onSave() {
                this.loading = true;
                this.$http.post('/api/Budget/CreateOrUpdate', this.budget).then(result => {
                    this.itemsToDelete = [];
                    this.budget.itemsToDelete = [];
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.loadData();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            onAddOrUpdateExpense(item) {
                this.loading = true;
                const payload = {
                    RegisterEntityId: this.budget.registerEntityId,
                    items: [item]
                }
                this.$http.post('/api/Expenses/AddOrUpdateItem', payload).then(result => {
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.loadData();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            pageChanged(page) {
                this.pagination.currentPage = page;
            },
            goToPage(page) {
                if (page >= 0 && page < this.totalPages) {
                    this.pagination.currentPage = page;
                }
            },
            filterData(item, search) {
                if (!search) return true;

                const searchTerm = search.toLowerCase();
                return (item.description || '').toLowerCase().includes(searchTerm) ||
                       (item.groupName || '').toLowerCase().includes(searchTerm) ||
                       (item.selectedTariffText || '').toLowerCase().includes(searchTerm) ||
                       (item.tariffEntityItem || '').toLowerCase().includes(searchTerm);
            }
        },
        watch: {
            templateId: function (newVal, oldVal) {
                this.populateFromTemplate(newVal);
            },
            searchString: {
                handler: function (newVal, oldVal) {
                    // Reset to first page when search changes
                    this.goToPage(0);
                },
                immediate: false
            },
            'budget.isExpensesGenerated': function(newVal, oldVal) {
                if (newVal && this.isLoaded) {
                    this.$vs.notify({
                        title: this.$t('budget.areYouSureYouWantToGenerateExpenses'),
                        text: this.$t('budget.youCanGenerateExpensesOnce'),
                        position: 'bottom-right',
                        color: 'warning',
                        time: 5000
                    });
                }
                this.isLoaded = true;
            }
        },
        mounted() {
            this.loadData();
            this.loadTariffOptions();
        },
    }
</script>
